import { setStateToStorage } from './storage'

export const initialState = {
  screen: 'titles',
  overlay: '',
  currentLevel: 0,
  // temporary position to display final arena overlay (podium)
  latestArenaResult: Number.MAX_SAFE_INTEGER,
  showEnding: false,
  arenas:[{
    type: 'granite',
    locked: false,
    name: 'Granite',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'sand',
    locked: true,
    name: 'Sand',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'malachite',
    locked: true,
    name: 'Malaquite',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'turquoise',
    locked: true,
    name: 'Turquoise',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'aragonite',
    locked: true,
    name: 'Aragonite',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'jasper',
    locked: true,
    name: 'Jasper',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'amethyst',
    locked: true,
    name: 'Amethyst',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'topaz',
    locked: true,
    name: 'Topaz',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'sulfur',
    locked: true,
    name: 'Sulfur',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'graphite',
    locked: true,
    name: 'Graphite',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'graphite',
    locked: true,
    name: 'The roof',
    result: Number.MAX_SAFE_INTEGER,
  }, {
    type: 'graphite',
    locked: true,
    name: 'The castle',
    result: Number.MAX_SAFE_INTEGER,
  }]
}

const app = (state, action) => {
  const switchObj = {
    NAVIGATE: () => ({
      ...state,
      screen: action.payload,
    }),
    SET_CURRENT_LEVEL: () => ({
      ...state,
      currentLevel: action.payload,
    }),
    SET_SHOW_ENDING: () => ({
      ...state,
      showEnding: action.payload,
    }),
    SET_ARENA_RESULT: () => {
      const arenas = [...state.arenas]
      const { arenaIndex, result } = action.payload
      // updates only best position
      const bestForArena = arenas[arenaIndex].result || Number.MAX_SAFE_INTEGER
      if (result < bestForArena) {
        arenas[arenaIndex].result = result
      }
      if (result <= 3 && arenas[arenaIndex + 1]) {
        // arena complete, unlock next arena
        arenas[arenaIndex + 1].locked = false
      }
      return {
        ...state,
        latestArenaResult: result,
        arenas,
      }
    },
    SET_OVERLAY: () => ({
      ...state,
      overlay: action.payload,
    }),
    UPDATE_STORED_PROGRESS: () => ({
      ...state,
      arenas: action.payload
    }),
    UPDATE_STATE_FROM_STORAGE: () => ({
      ...action.payload
    }),
    DEFAULT: () => ({ ...state })
  }
  // switch (action.type) {
  //   case "NAVIGATE":
  //     stateObj = {
  //       ...state,
  //       screen: action.payload,
  //     };
  //   case "SET_CURRENT_LEVEL":
  //     stateObj = {
  //       ...state,
  //       currentLevel: action.payload,
  //     }
  //   case "SET_ARENA_RESULT":
  //     const arenas = [...state.arenas]
  //     const { arenaIndex, result } = action.payload
  //     // updates only best position
  //     const bestForArena = arenas[arenaIndex].result || Number.MAX_SAFE_INTEGER
  //     if (result < bestForArena) {
  //       arenas[arenaIndex].result = result
  //     }
  //     if (result <= 3) {
  //       // arena complete, unlock next arena
  //       arenas[arenaIndex + 1].locked = false
  //     }
  //     stateObj = {
  //       ...state,
  //       latestArenaResult: result,
  //       arenas,
  //     }
  //   case "SET_OVERLAY":
  //     stateObj = {
  //       ...state,
  //       overlay: action.payload,
  //     }
  //   default:
  //     stateObj = state
  // }
  const newState = switchObj.hasOwnProperty(action.type) ? switchObj[action.type]() : switchObj.DEFAULT()
  setStateToStorage(newState)
  return newState
};

export default app
